export default {
  queuesList: [],
};
